import React from 'react'
import Box from '@mui/material/Box'

import { arrowDown, arrowUp } from '../../assets/images/icons'

import { DataGrid as Grid } from '@mui/x-data-grid'
import MuiImage from '../muiImage'
import NoDataFound from '../noDataFound'
import Loader from '../loader'

const DataGrid = ({ columns = [], rows = [], isLoading }) => {
  const handleClicked = (event) => {
    const selectedColumnName = event.currentTarget.dataset.field
    const selectedRowDataset = event.currentTarget.parentElement.dataset
    const selectedRow = rows.find((r) => r.id === selectedRowDataset.id)
  }

  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 360px)', mt: 1 }}>
      <Grid
        className='gridWrap'
        sx={{
          '& .MuiDataGrid-cell': {
            width: '100%',
            borderBottom: '1px solid #F1F1F3',
          },
          '& .MuiDataGrid-columnHeader': {
            borderBottom: '2px solid #F1F1F3',
          },
          '& .MuiDataGrid-footerContainer': {
            display: 'none',
          },
        }}
        columns={columns}
        rows={rows}
        components={{
          ColumnSortedAscendingIcon: () => <MuiImage src={arrowDown} />,
          ColumnSortedDescendingIcon: () => <MuiImage src={arrowUp} />,
          NoRowsOverlay: () => (
            <Box sx={{ marginTop: 3 }}>
              <NoDataFound title='No projects yet' loader={isLoading ? <Loader /> : null} />
            </Box>
          ),
          // Toolbar: GridToolbar
          // ColumnSortedDescendingIcon: <img src={arrowDown} width='20' />,
          // ColumnSortedAscendingIcon: arrowUp
        }}
        // componentsProps={{
        //   cell: {
        //     onClick: handleClicked
        //   },
        // }}
        // // density="compact"
        hideFooterPagination={true}
        hideFooterSelectedRowCount={true}
        disableColumnMenu={true}
      />
    </Box>
  )
}

export default DataGrid
